import { render } from "./ProfileBlock.vue?vue&type=template&id=4597e892&scoped=true"
import script from "./ProfileBlock.vue?vue&type=script&lang=js"
export * from "./ProfileBlock.vue?vue&type=script&lang=js"

import "./ProfileBlock.vue?vue&type=style&index=0&id=4597e892&lang=scss&scoped=true"

import exportComponent from "C:\\inetpub\\wwwroot\\areaclienti.luceegasitalia.it\\areaclienti\\areaclienti\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4597e892"]])

export default __exports__